<script>
    import { delay } from '@superbet-group/web.lib.utilities';

    import { markFirstVisit } from '@models/user/UserDataService';

    import HtmlLandingPage from './HtmlLandingPage';
    import NapoleonHub from './NapoleonHub';
    import { RouteName } from '@app/router/constants/RouteName';
    import { mapGetters } from 'vuex';
    import {
        getConfig,
        IntroPageType,
    } from '@superbet-group/web.lib.config';
    import { isXtremePushLoaded } from '@core/services/inbox/InboxService';
    import { getShellConfig } from '@src/config/shell/config';

    export default {
        created() {
            const XPdata = JSON.parse(localStorage.getItem('xtremepush.data'));
            if (isXtremePushLoaded() && XPdata?.permission === 'default') {
                window.xtremePush('push', 'auto_prompt', false);
            }
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
        },
        watch: {
            user(newValue, oldValue) {
                let isLoggedIn = !!newValue;
                if (isLoggedIn && oldValue == null) {
                    this.redirectToPromoPage();
                }
            },
        },
        methods: {
            async markFirstVisit() {
                /**
                 * Fixes chrome error. It was only happening on superbet.ro. Every save to localStorage
                 * for the first few seconds didn't save
                 */
                await delay(1000);
                markFirstVisit();
            },
            redirectToPromoPage() {
                if (getConfig().introPageSetup.type === IntroPageType.ShowOnce) {
                    this.$router.push({ name: RouteName.BonusAndComms.PromotionHub });
                }
            },
        },
        render(createElement) {
            const commonAttrs = {
                on: {
                    markFirstVisit: this.markFirstVisit,
                },
            };
            return createElement(getShellConfig().remoteConfig.areSitesSplitByLicence ? NapoleonHub : HtmlLandingPage, commonAttrs);
        },
        components: {
            HtmlLandingPage,
        },
    };
</script>
